import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { baseBorderColor, colorNameMap } from "../../colorNameMap";
import { computeColor } from "../../computeColor";
// TODO: move context to shared-frontend package and initialize default values to be used in shared components in EDST.
// this will avoid prop drilling colors in shared frontend components.
export const BrightContext = React.createContext({
    buttonBright: 1,
    borderBright: 1,
    textBright: 1,
    borderTint: colorNameMap.darkGrey,
    tint: colorNameMap.lightGrey,
    fillColor: colorNameMap.grey,
});
export const useBrightContext = () => {
    return React.useContext(BrightContext);
};
export function createBrightContextProvider(useBrightnessValues) {
    return function AppBrightContextProvider({ children }) {
        const { BUTTON_BRIGHT, BORDER_BRIGHT, TEXT_BRIGHT } = useBrightnessValues();
        const borderTint = computeColor(baseBorderColor, BORDER_BRIGHT / 100);
        const tint = computeColor(colorNameMap.white, TEXT_BRIGHT / 100);
        const fillColor = computeColor(colorNameMap.grey, BUTTON_BRIGHT / 100);
        return (_jsx(BrightContext.Provider, { value: {
                borderTint,
                tint,
                fillColor,
                buttonBright: BUTTON_BRIGHT / 100,
                borderBright: BORDER_BRIGHT / 100,
                textBright: TEXT_BRIGHT / 100,
            }, children: children }));
    };
}
//# sourceMappingURL=brightContext.js.map